import https from "./https";

const auth = {
  login(params) {
    return https.post("/dashboard/auth/login", params);
  },
  loginByToken(params) {
    return https.post("/dashboard/auth/login-by-token", params);
  },
  loginBySso(params) {
    return https.post("/dashboard/auth/login-by-shopline-sso", params);
  },
  verifyOtp(params) {
    return https.post("/dashboard/auth/verify-otp", params);
  },
  resendOtp(params) {
    return https.post("/dashboard/auth/resend-otp", params);
  },
  oAuthLogin(params) {
    return https.post("/oauth/login", params);
  },
  fetchMe() {
    return https.get("/admin/me");
  }
};

export default auth;
